import { FC, useCallback, useMemo } from 'react'

import { FormikProps } from 'formik'
import { onFormikTextChanges, useTranslator } from 'ufinet-web-functions'

import { DatePicker, DatePickerTypeEnum, UfinetInput, UfinetSectionBox } from 'ufinet-web-components'
import { CreateFtthIncidentFormikType } from '../CreateIncidentFormikType'
import { onFormikTextChangesValidation } from '../../../../utils/formikHelpersValidation';

interface ContactInfoSectionProps {
	formik: FormikProps<CreateFtthIncidentFormikType>
}

const ContactInfoSection: FC<ContactInfoSectionProps> = ({ formik }) => {
	const translate = useTranslator()
	const { values, errors, setFieldValue } = formik

	const onTextChange = useCallback(onFormikTextChanges, [])
	const nowDate = useMemo(() => new Date(), [])

	return (
		<UfinetSectionBox title="contact_info" className="mb-5 p-5">
			<h4>{translate('TICKET.NEW.TITLE.VISIT.INFO')}</h4>
			<div className="row">
				<UfinetInput
					type="text"
					value={values.visitContactName}
					id="visit_contact_name"
					solid={false}
					labelTitle={translate('TICKET.NEW.VISIT.CONTACT')}
					className="col-12 col-md-6 mt-3"
					onChange={onFormikTextChangesValidation(formik, 'visitContactName')}
					error={errors.visitContactName}
				/>
				<UfinetInput
					type="text"
					value={values.visitContactPhone}
					id="visit_contact_phone"
					solid={false}
					labelTitle={translate('TICKET.NEW.VISIT.PHONE')}
					className="col-12 col-md-6 mt-3"
					onChange={onFormikTextChangesValidation(formik, 'visitContactPhone')}
					error={errors.visitContactPhone}
				/>
			</div>
			<div className="row">
				<UfinetInput
					type="text"
					value={values.visitRequirements}
					id="visit_requirements"
					solid={false}
					labelTitle={translate('TICKET.NEW.VISIT.REQUIREMENTS')}
					className="col mt-3"
					onChange={onFormikTextChangesValidation(formik, 'visitRequirements')}
					error={errors.visitRequirements}
				/>
			</div>
			<div className="row">
				<DatePicker
					type={DatePickerTypeEnum.DATE_TIME}
					timeFormat="24"
					value={values.visitDate}
					id="visiting_hours"
					label={translate('TICKET.NEW.VISIT.TIMESTAMP')}
					className="col mt-3"
					onChange={onTextChange(formik, 'visitDate')}
					min={nowDate}
				/>
			</div>
		</UfinetSectionBox>
	)
}

export { ContactInfoSection }
